import Input from 'Components/Input'
import Modal from 'Components/Modal'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import project from 'EurestoConfig/project.config'
import Utils from 'EurestoFonction/Utils'
import React, { useEffect, useState } from 'react'
import DataGrid from '../../../App/Module/CRM/Component/Table'
import AjoutContact from '../../../App/Module/CRM/Page/Ajout'



export default (props) => {
  const [open, setOpen] = useState(false)
  const [libelle, setLibelle] = useState('')
  const [key, setKey] = useState(Utils.getRandomNumber())
  const [addNewContact, setAddNewContact] = useState(props.ajoutContact ? -1 : 0)

  const handleClickModalContact = (o) => {
    setAddNewContact(-1)
    setOpen(o)
  }

  const onSelectContact = (row) => {
    setOpen(false)
    setKey(Utils.getRandomNumber())
    props.onChange && props.onChange(row.id, props.name || 'contact_id', row)
  }

  const addContact = () => {
    setAddNewContact(1)
  }

  useEffect(() => {
    const fetchData = async () => {
      if (props.contact_id) {
        const result = await ApiRequest(project.api + 'crm', {
          action: 'get',
          requete: 'client',
          id: props.contact_id
        }, { showAlertError: false })
        if (result && result.code === 1 && result.results) {
          setLibelle(result.results.libelle || '')
          setKey(Utils.getRandomNumber())
        } else {
          setLibelle('')
          setKey(Utils.getRandomNumber())
        }
      } else {
        setLibelle('')
        setKey(Utils.getRandomNumber())
      }
    }
    fetchData()
  }, [props.contact_id])

  const ModalContact = <Modal open={open || false} onClose={() => handleClickModalContact(false)}
      grid={{ xs: 8 }}>
    <EurestoDiv
      buttonsLeft={addNewContact === -1 && [
        {
          title: 'Ajouter',
          icon: ' ei-commun_ajouter',
          cb: addContact
        }
      ]}
        buttonsRight={[{
          icon: ' ei-commun_fermer',
          className: 'EurestoError--text EurestoText',
          cb: () => handleClickModalContact(false)
        }]}
        style={{
          margin: 0,
          padding: 10,
          maxHeight: User.CalculHeight.getHeightWanted(70),
          height: User.CalculHeight.getHeightWanted(70),
          overflowY: 'auto'
        }}>
      {addNewContact === -1 ?
          <DataGrid onClick={onSelectContact} searchProps={props.search} view={'list'} defaultSearch={props.defaultSearch || {}} style={{
            maxHeight: User.CalculHeight.getHeightWanted(70),
        }} type={"client"} name={'sdd-'} showSearch={true} /> :
        <AjoutContact modalHeight={50} handleSaveContact={onSelectContact} handleCancelContact={() => handleClickModalContact(false)} />
        }
      </EurestoDiv>
    </Modal>

  return <React.Fragment>
    <Input
      inline={props.inline}
      key={key}
      disabled={props.disabled}
      onClick={() => !props.disabled && handleClickModalContact(true)}
      className="upText"
      title={props.title || 'Client'}
      type="text"
      value={libelle || ''}
      InputProps={{
        startAdornment: (
          <i style={{ zIndex: 3 }} className={'ei-commun_rechercher'} />
        ),
        endAdornment: (
          !props.disabled && props.contact_id &&
          <i onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setLibelle('')
            setKey(Utils.getRandomNumber())
            props.onChange && props.onChange(undefined, props.name || 'contact_id')
          }}
            style={{ zIndex: 3, marginRight: 7.5 }}
            className={'ei-commun_fermer EurestoError--text cursor-pointer'} />
        )
      }}
    />
    {ModalContact}
  </React.Fragment>
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/InputClient/index.js